import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-m15__message c-form-inner--wide" }
const _hoisted_2 = { class: "p-the-page-m15__message__text" }
const _hoisted_3 = { class: "p-form-button-group" }
const _hoisted_4 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheTemplateM = _resolveComponent("TheTemplateM")!

  return (_openBlock(), _createBlock(_component_TheTemplateM, {
    class: "p-the-page-m15",
    "is-simple-header": true,
    step: _ctx.step,
    "step-options": _ctx.stepOptions
  }, {
    heading: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("メールアドレス変更", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ButtonMain, {
              tag: 'a',
              href: "/login/"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("ログインする", -1)
              ])),
              _: 1,
              __: [1]
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["step", "step-options"]))
}